/**
 * Success Confirmation Component
 *
 * Shows "Calculating prices..." while the price query that fires after
 * insurance lands in the store is still in flight, then flips to the
 * "Your insurance is connected!" confetti state.
 *
 * The parent state machine auto-closes this view after 10s. If prices are
 * fast (the common case), the user still sees the calculating pill briefly
 * before the success state, matching the loading treatment used on the
 * storefront's PriceToggle.
 */

"use client";

import confettiAnimation from "@/public/lottie-animations/confetti.json";
// import { CalculatingPricesPill } from "@frontend/components/priceToggle/CalculatingPricesPill";
import { useIsFetching } from "@tanstack/react-query";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import { useTranslations } from "@frontend/lib/next-intl-typed";

interface SuccessConfirmationProps {
  isMobile?: boolean;
}

export const SuccessConfirmation = ({
  isMobile = false,
}: SuccessConfirmationProps) => {
  const t = useTranslations("InsuranceConnector");
  const isFetchingPrice = !!useIsFetching({ queryKey: ["updatePrices"] });

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className={`rounded-3xl ${isMobile ? "w-full p-4" : "w-96 p-4"}`}
    >
      {/* {isFetchingPrice ? (
        <div className="flex flex-col gap-6 w-full">
          <CalculatingPricesPill />
          <p className="text-lg">{t("ApplyingBenefits")}</p>
        </div>
      ) : ( */}
      <div className="flex flex-col gap-6 w-full">
        <div className="w-16 h-16">
          <Lottie animationData={confettiAnimation} loop={false} />
        </div>

        <p className="text-2xl font-semibold">{t("InsuranceConnected")}</p>

        <p className="text-lg">{t("ShopWithBenefits")}</p>
      </div>
      {/* )} */}
    </motion.div>
  );
};
